import Vue from 'vue'
import Vuex from 'vuex'
import _debounce from 'lodash.debounce'
import { getDefaultValue } from '@/utilities'

import feathers from '@/feathers/'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    feathers,
    services: {
      auth: feathers.service('authentication'),
      users: feathers.service('users'),
      log: feathers.service('log'),
      apls: feathers.service('apls'),
      statuses: feathers.service('statuses'),
      categories: feathers.service('categories'),
      markers: feathers.service('markers'),
      userTypes: feathers.service('usertypes'),
      propertyGroups: feathers.service('propertygroups'),
      properties: feathers.service('properties'),
      details: feathers.service('details'),
      dictionary: feathers.service('dictionary'),
      i18n: feathers.service('i18n'),
      language: feathers.service('language'),
      rest: feathers.service('rest'),
      geojson: feathers.service('geojson')
    },
    auth: {
      user: null,
      token: null
    },
    log: {
      items: [],
      page: 1,
      limit: 10,
      totalPages: 10,
      type: 'all',
      search: null
    },
    apls: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    },
    statuses: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null,
      apl_id: null,
      category_id: null
    },
    categories: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    },
    markers: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null,
      apl_id: null,
      category_id: null,
      status_id: null,
      availability: null
    },
    userTypes: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    },
    propertyGroups: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null,
      apls_id: null
    },
    properties: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null,
      apl_id: null,
      propertygroup_id: null
    },

    currentLanguage: getDefaultValue('language'),

    currentAPL: null,

    dictionary: {
      keys: [],
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    },

    language: {
      keys: [],
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    },

    dictionaryGeneration: {
      loading: false,
      complete: false
    },
    dictionaryImportProgress: {
      value: 0,
      visible: false
    },

    // apl uniques
    aplsUniques: [],
    // apl slugs
    aplsSlugs: [],
    // marker uniques
    uniquesForApl: [],

    theme: getDefaultValue('theme'),

    users: {
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true
      },
      search: null
    }
  },
  getters: {
    user: state => state.auth.user,

    logItems: state => state.log.items,
    logType: state => state.log.type,
    logLimit: state => state.log.limit,
    logPage: state => state.log.page,
    logTotalPages: state => state.log.totalPages,
    logSearch: state => state.log.search,

    aplItems: state => state.apls.items,
    aplsTotal: state => state.apls.total,
    aplsLoading: state => state.apls.loading,
    aplsOptions: state => state.apls.options,
    aplsSearch: state => state.apls.search,

    statusesItems: state => state.statuses.items,
    statusesTotal: state => state.statuses.total,
    statusesLoading: state => state.statuses.loading,
    statusesOptions: state => state.statuses.options,
    statusesSearch: state => state.statuses.search,
    statusesAPL: state => state.statuses.apl_id,
    statusesCategory: state => state.statuses.category_id,

    categoriesItems: state => state.categories.items,
    categoriesTotal: state => state.categories.total,
    categoriesLoading: state => state.categories.loading,
    categoriesOptions: state => state.categories.options,
    categoriesSearch: state => state.categories.search,
    categoriesAPL: state => state.categories.apl_id,

    markersItems: state => state.markers.items,
    markersTotal: state => state.markers.total,
    markersLoading: state => state.markers.loading,
    markersOptions: state => state.markers.options,
    markersSearch: state => state.markers.search,
    markersAPL: state => state.markers.apl_id,
    markersStatus: state => state.markers.status_id,
    markersCategory: state => state.markers.category_id,
    markersAvailability: state => state.markers.availability,

    userTypesItems: state => state.userTypes.items,
    userTypesTotal: state => state.userTypes.total,
    userTypesLoading: state => state.userTypes.loading,
    userTypesOptions: state => state.userTypes.options,
    userTypesSearch: state => state.userTypes.search,

    propertyGroupsItems: state => state.propertyGroups.items,
    propertyGroupsTotal: state => state.propertyGroups.total,
    propertyGroupsLoading: state => state.propertyGroups.loading,
    propertyGroupsOptions: state => state.propertyGroups.options,
    propertyGroupsSearch: state => state.propertyGroups.search,
    propertyGroupsAPL: state => state.propertyGroups.apl_id,

    propertiesItems: state => state.properties.items,
    propertiesTotal: state => state.properties.total,
    propertiesLoading: state => state.properties.loading,
    propertiesOptions: state => state.properties.options,
    propertiesSearch: state => state.properties.search,
    propertiesAPL: state => state.properties.apl_id,
    propertiesPropertyGroup: state => state.properties.propertygroup_id,

    currentAPL: state => state.currentAPL,

    dictionaryItems: state => state.dictionary.items,
    dictionaryKeys: state => state.dictionary.keys,
    dictionaryTotal: state => state.dictionary.total,
    dictionaryLoading: state => state.dictionary.loading,
    dictionaryOptions: state => state.dictionary.options,
    dictionarySearch: state => state.dictionary.search,

    languageItems: state => state.language.items,
    languageKeys: state => state.language.keys,
    languageTotal: state => state.language.total,
    languageLoading: state => state.language.loading,
    languageOptions: state => state.language.options,
    languageSearch: state => state.language.search,

    currentLanguage: state => state.currentLanguage,
    languages: state => state.language.items,
    languageCodes: state => state.language.items.map(lang => lang.languageCode),

    dictionaryGenerationComplete: state => state.dictionaryGeneration.complete,
    dictionaryGenerationLoading: state => state.dictionaryGeneration.loading,

    dictionaryImportProgressVisible: state => state.dictionaryImportProgress.visible,
    dictionaryImportProgressValue: state => state.dictionaryImportProgress.value,

    uniquesForApl: state => state.uniquesForApl,

    selectedMapStyle: state => state.theme,

    theme: state => state.theme,

    usersItems: state => state.users.items,
    usersTotal: state => state.users.total,
    usersLoading: state => state.users.loading,
    usersOptions: state => state.users.options,
    usersSearch: state => state.users.search,
    usersAPL: state => state.users.apl_id,
    usersUsernames: state => state.users.usernames,
    usersEmails: state => state.users.emails,

    aplsUniques: state => state.aplsUniques,
    aplsSlugs: state => state.aplsSlugs
  },
  mutations: {
    setAuth (state, payload) {
      Vue.set(state.auth, 'user', payload.user)
      Vue.set(state.auth, 'token', payload.accessToken)
    },

    setLogItems (state, payload) {
      Vue.set(state.log, 'items', payload.data)
      Vue.set(state.log, 'totalPages', Math.ceil(payload.total / state.log.limit))
    },
    setLogItemsType (state, payload) {
      Vue.set(state.log, 'type', payload)
    },
    setLogItemsPage (state, payload) {
      Vue.set(state.log, 'page', payload)
    },
    setLogItemsLimit (state, payload) {
      Vue.set(state.log, 'limit', payload)
    },
    setLogSearch (state, payload) {
      Vue.set(state.log, 'search', payload)
    },

    setAPLsLoading (state, payload) {
      state.apls.loading = payload
    },
    setAPLs (state, payload) {
      if (payload.data) {
        state.apls.items = payload.data
        state.apls.total = payload.total
      } else {
        state.apls.items = payload
        state.apls.total = payload.length
      }
    },
    setAPLsOptions (state, payload) {
      state.apls.options = payload
    },
    setAPLsSearch (state, payload) {
      state.apls.search = payload
    },

    setStatusesLoading (state, payload) {
      state.statuses.loading = payload
    },
    setStatuses (state, payload) {
      if (payload.data) {
        state.statuses.items = payload.data
        state.statuses.total = payload.total
      } else {
        state.statuses.items = payload
        state.statuses.total = payload.length
      }
    },
    setStatusesOptions (state, payload) {
      state.statuses.options = payload
    },
    setStatusesSearch (state, payload) {
      state.statuses.search = payload
    },
    setStatusesApl (state, payload) {
      state.statuses.apl_id = payload
    },
    setStatusesCategory (state, payload) {
      state.statuses.category_id = payload
    },

    setCategoriesLoading (state, payload) {
      state.categories.loading = payload
    },
    setCategories (state, payload) {
      if (payload.data) {
        state.categories.items = payload.data
        state.categories.total = payload.total
      } else {
        state.categories.items = payload
        state.categories.total = payload.length
      }
    },
    setCategoriesOptions (state, payload) {
      state.categories.options = payload
    },
    setCategoriesSearch (state, payload) {
      state.categories.search = payload
    },
    setCategoriesApl (state, payload) {
      state.categories.apl_id = payload
    },

    setMarkersLoading (state, payload) {
      state.markers.loading = payload
    },
    setMarkers (state, payload) {
      if (payload.data) {
        state.markers.items = payload.data
        state.markers.total = payload.total
      } else {
        state.markers.items = payload
        state.markers.total = payload.length
      }
    },
    setMarkersOptions (state, payload) {
      state.markers.options = payload
    },
    setMarkersSearch (state, payload) {
      state.markers.search = payload
    },
    setMarkersApl (state, payload) {
      state.markers.apl_id = payload
    },
    setMarkersStatus (state, payload) {
      state.markers.status_id = payload
    },
    setMarkersCategory (state, payload) {
      state.markers.category_id = payload
    },
    setMarkersAvailability (state, payload) {
      state.markers.availability = payload
    },

    setUserTypesLoading (state, payload) {
      state.userTypes.loading = payload
    },
    setUserTypes (state, payload) {
      if (payload.data) {
        state.userTypes.items = payload.data
        state.userTypes.total = payload.total
      } else {
        state.userTypes.items = payload
        state.userTypes.total = payload.length
      }
    },
    setUserTypesOptions (state, payload) {
      state.userTypes.options = payload
    },
    setUserTypesSearch (state, payload) {
      state.userTypes.search = payload
    },

    setPropertyGroupsLoading (state, payload) {
      state.propertyGroups.loading = payload
    },
    setPropertyGroups (state, payload) {
      if (payload.data) {
        state.propertyGroups.items = payload.data
        state.propertyGroups.total = payload.total
      } else {
        state.propertyGroups.items = payload
        state.propertyGroups.total = payload.length
      }
    },
    setPropertyGroupsOptions (state, payload) {
      state.propertyGroups.options = payload
    },
    setPropertyGroupsSearch (state, payload) {
      state.propertyGroups.search = payload
    },
    setPropertyGroupsApl (state, payload) {
      state.propertyGroups.apl_id = payload
    },

    setPropertiesLoading (state, payload) {
      state.properties.loading = payload
    },
    setProperties (state, payload) {
      if (payload.data) {
        state.properties.items = payload.data
        state.properties.total = payload.total
      } else {
        state.properties.items = payload
        state.properties.total = payload.length
      }
    },
    setPropertiesOptions (state, payload) {
      state.properties.options = payload
    },
    setPropertiesSearch (state, payload) {
      state.properties.search = payload
    },
    setPropertiesApl (state, payload) {
      state.properties.apl_id = payload
    },
    setPropertiesPropertyGroup (state, payload) {
      state.properties.propertygroup_id = payload
    },

    setCurrentAPL (state, payload) {
      state.currentAPL = payload
    },

    setDictionaryLoading (state, payload) {
      state.dictionary.loading = payload
    },
    setDictionary (state, payload) {
      if (payload.data) {
        state.dictionary.items = payload.data
        state.dictionary.total = payload.total
      } else {
        state.dictionary.items = payload
        state.dictionary.total = payload.length
      }
    },
    setDictionaryKeys (state, payload) {
      state.dictionary.keys = payload.map(term => term.key)
    },
    setDictionaryOptions (state, payload) {
      state.dictionary.options = payload
    },
    setDictionarySearch (state, payload) {
      state.dictionary.search = payload
    },

    setLanguageLoading (state, payload) {
      state.language.loading = payload
    },
    setLanguage (state, payload) {
      if (payload.data) {
        state.language.items = payload.data
        state.language.total = payload.total
      } else {
        state.language.items = payload
        state.language.total = payload.length
      }
    },
    setLanguageKeys (state, payload) {
      state.language.keys = payload.map(term => term.languageCode)
    },
    setLanguageOptions (state, payload) {
      state.language.options = payload
    },
    setLanguageSearch (state, payload) {
      state.language.search = payload
    },

    resetLogPage (state) {
      Vue.set(state.log, 'page', 1)
    },
    resetAplsPage (state) {
      Vue.set(state.apls.options, 'page', 1)
    },
    resetStatusesPage (state) {
      Vue.set(state.statuses.options, 'page', 1)
    },
    resetCategoriesPage (state) {
      Vue.set(state.categories.options, 'page', 1)
    },
    resetMarkersPage (state) {
      Vue.set(state.markers.options, 'page', 1)
    },
    resetUserTypesPage (state) {
      Vue.set(state.userTypes.options, 'page', 1)
    },
    resetPropertyGroupsPage (state) {
      Vue.set(state.propertyGroups.options, 'page', 1)
    },
    resetPropertiesPage (state) {
      Vue.set(state.properties.options, 'page', 1)
    },
    resetDictionaryPage (state) {
      Vue.set(state.dictionary.options, 'page', 1)
    },
    resetlanguagePage (state) {
      Vue.set(state.language.options, 'page', 1)
    },

    setCurrentLanguage (state, payload) {
      state.currentLanguage = payload
      localStorage.setItem('currentLanguage', JSON.stringify(payload))

      window.location.reload()
    },

    setDictionaryGenerationComplete (state, payload) {
      state.dictionaryGeneration.complete = payload
    },
    setDictionaryGenerationLoading (state, payload) {
      state.dictionaryGeneration.loading = payload
    },

    setDictionaryImportProgressValue (state, payload) {
      state.dictionaryImportProgress.value = payload
    },
    setDictionaryImportProgressVisible (state, payload) {
      state.dictionaryImportProgress.visible = payload
    },

    setUniquesForAPl (state, payload) {
      state.uniquesForApl = payload
    },

    setTheme (state, payload) {
      state.theme = payload
      localStorage.setItem('theme', payload)
    },

    setUsersLoading (state, payload) {
      state.users.loading = payload
    },
    setUsers (state, payload) {
      if (payload.data) {
        state.users.items = payload.data
        state.users.total = payload.total
      } else {
        state.users.items = payload
        state.users.total = payload.length
      }
    },
    setUsersOptions (state, payload) {
      state.users.options = payload
    },
    setUsersSearch (state, payload) {
      state.users.search = payload
    },
    setUsersUsernames (state, payload) {
      state.users.usernames = payload.map(term => term.username)
    },
    setUsersEmails (state, payload) {
      state.users.emails = payload.map(term => term.email)
    },
    setAplsUniques (state, payload) {
      state.aplsUniques = payload
    },
    setAplsSlugs (state, payload) {
      state.aplsSlugs = payload
    }
  },
  actions: {
    async reAuth ({ state, commit, dispatch }) {
      try {
        const response = await state.feathers.reAuthenticate()
        commit('setAuth', response)
        dispatch('saveLogItem', { type: 'success', user: response.user.username, text: '(auth) Autentificare reusita!' })
        return true
      } catch (err) {
        console.log(err)
        return false
      }
    },
    async login ({ state, commit, dispatch }, payload) {
      try {
        const response = await state.feathers.authenticate({
          strategy: 'local',
          ...payload
        })
        commit('setAuth', response)
        dispatch('saveLogItem', { type: 'success', user: response.user.username, text: '(auth) Autentificare reusita!' })
        return true
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: payload.email, text: '(auth) Autentificare esuata!' })
        return false
      }
    },
    async logout ({ state, commit, dispatch }) {
      dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(auth) Iesire din aplicatie.' })
      await state.feathers.logout()
      commit('setAuth', { user: null, accessToken: null })
    },

    fetchLog: _debounce(async function ({ state, commit }) {
      if (state.auth.user) {
        try {
          const query = {
            query: {
              $skip: (state.log.page - 1) * state.log.limit,
              $limit: state.log.limit,
              $sort: {
                createdAt: -1
              }
            }
          }
          if (state.log.type !== 'all') {
            query.query.type = state.log.type
          }
          if (state.log.search) {
            query.query.text = { $regex: state.log.search, $options: 'i' }
          }
          const response = await state.services.log.find(query)
          commit('setLogItems', response)
        } catch (err) {
          console.log(err)
          // dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(log) Eroare la citire log...' })
        }
      }
    }, 500),
    setLogItemsType ({ commit, dispatch }, payload) {
      commit('setLogItemsType', payload)
      dispatch('fetchLog')
    },
    setLogItemsPage ({ commit, dispatch }, payload) {
      commit('setLogItemsPage', payload)
      dispatch('fetchLog')
    },
    setLogItemsLimit ({ commit, dispatch }, payload) {
      commit('setLogItemsLimit', payload)
      dispatch('fetchLog')
    },
    setLogSearch ({ commit, dispatch }, payload) {
      commit('setLogSearch', payload)
      commit('resetLogPage')
      dispatch('fetchLog')
    },
    async saveLogItem ({ state, dispatch }, payload) {
      try {
        await state.services.log.create(payload)
        dispatch('fetchLog')
      } catch (err) {
        console.log(err)
      }
    },
    async deleteLogItem ({ state, dispatch }, payload) {
      try {
        // if payload is null add query to delete all
        // query is built with the help of state.log keys of page, limit, type, search

        // else just delete the item

        if (payload === null) {
          const query = {
            query: {
              $skip: (state.log.page - 1) * state.log.limit,
              $limit: state.log.limit,
              $sort: {
                createdAt: -1
              }
            }
          }

          if (state.log.type !== 'all') {
            query.query.type = state.log.type
          }
          if (state.log.search) {
            query.query.text = { $regex: state.log.search, $options: 'i' }
          }

          await state.services.log.remove(null, query)
        } else {
          await state.services.log.remove(payload)
        }

        dispatch('fetchLog')
      } catch (err) {
        console.log(err)
      }
    },

    async getAPL ({ state }, payload) {
      if (payload) {
        try {
          const apl = await state.services.apls.get(payload)

          return apl
        } catch (err1) {
          try {
            const result = await state.services.apls.find({
              query: {
                slug: payload
              }
            })

            return result.data[0]
          } catch (err2) {
            return null
          }
        }
      }

      return null
    },
    fetchAllAPLs ({ state }, payload) {
      const query = {
        $paginate: false,
        $populate: ['markerCount', 'categoryCount', 'statusCount', 'propertyGroupCount', 'propertyCount']
      }

      if (payload) {
        query.visible = true
      }

      return state.services.apls.find({ query })
    },
    fetchAPLs: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setAPLsLoading', true)

        let query = {
          $populate: [
            'markerCount',
            'categoryCount',
            'statusCount',
            'propertyGroupCount',
            'propertyCount'
          ]
        }

        if (state.auth.user && state.apls.options.itemsPerPage) {
          if (state.apls.search) {
            query.$or = [
              { name: { $regex: state.apls.search, $options: 'i' } },
              { county: { $regex: state.apls.search, $options: 'i' } }
            ]
          }

          if (state.apls.options.itemsPerPage !== -1) {
            query.$limit = state.apls.options.itemsPerPage
            query.$skip = (state.apls.options.page - 1) * state.apls.options.itemsPerPage
            query.$sort = state.apls.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.apls.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.apls.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.apls.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            visible: true,
            $paginate: false
          }
        }

        const result = await state.services.apls.find({ query })
        commit('setAPLs', result)
        commit('setAPLsLoading', false)
        dispatch('fetchAplsUniques')
        dispatch('fetchAplsSlugs')
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(APLs) Eroare la citire APL-uri...' })
      }
    }, 500),
    async saveAPL ({ state, dispatch }, payload) {
      if (payload.logo.buffer instanceof File) {
        payload.buffer = await readFile(payload.logo.buffer)
        delete payload.logo.buffer
      }

      if (payload._id) {
        try {
          await state.services.apls.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(APLs) Modificat APL: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(APLs) Eroare modificare APL: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.apls.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(APLs) Creat APL: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(APLs) Eroare creare APL: ' + err.message })
        }
      }
      dispatch('fetchAPLs')
    },
    async deleteAPL ({ state, dispatch }, payload) {
      try {
        await state.services.apls.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(APLs) Eroare stergere APL: ' + err.message })
      }
      dispatch('fetchAPLs')
    },
    setAPLsOptions ({ commit, dispatch }, payload) {
      commit('setAPLsOptions', payload)
      dispatch('fetchAPLs')
    },
    setAPLsSearch ({ commit, dispatch }, payload) {
      commit('setAPLsSearch', payload)
      commit('resetAplsPage')
      dispatch('fetchAPLs')
    },

    fetchAllStatuses ({ state }, payload) {
      if (payload && payload.apl_id) {
        const query = {
          $paginate: false,
          apl_id: payload.apl_id,
          $populate: [
            { path: 'category_id', model: 'categories', populate: ['markerCount'] },
            { path: 'markerCount' }
          ],
          $sort: {
            category_id: 1
          }
        }

        return state.services.statuses.find({ query })
      } else {
        return state.services.statuses.find({
          query: {
            $paginate: false,
            $populate: [
              { path: 'category_id', model: 'categories' },
              { path: 'markerCount' }
            ]
          }
        })
      }
    },
    fetchStatuses: _debounce(async function ({ state, commit, dispatch }, payload = null) {
      try {
        commit('setStatusesLoading', true)

        let query = {
          $populate: [
            { path: 'apl_id', populate: ['markerCount', 'categoryCount', 'statusCount'] },
            { path: 'category_id', model: 'categories', populate: ['markerCount', 'statusCount'] },
            { path: 'markerCount' }
          ]
        }

        if (payload) {
          query.apl_id = payload
        }

        if (state.auth.user && state.statuses.options.itemsPerPage) {
          if (state.statuses.apl_id !== null) {
            query.apl_id = state.statuses.apl_id
          }
          if (state.statuses.category_id !== null) {
            query.category_id = state.statuses.category_id
          }

          if (state.statuses.search) {
            query.$or = [
              { name: { $regex: state.statuses.search, $options: 'i' } },
              { value: { $regex: state.statuses.search, $options: 'i' } }
            ]
          }

          if (state.statuses.options.itemsPerPage !== -1) {
            query.$limit = state.statuses.options.itemsPerPage
            query.$skip = (state.statuses.options.page - 1) * state.statuses.options.itemsPerPage
            query.$sort = state.statuses.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.statuses.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.statuses.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.statuses.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }

          if (payload) {
            query.apl_id = payload
          }
        }

        const result = await state.services.statuses.find({ query })
        commit('setStatuses', result)
        commit('setStatusesLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Statuses) Eroare la citire Statusuri...' })
      }
    }, 500),
    async saveStatus ({ state, dispatch }, payload) {
      if (payload.icon.buffer instanceof File) {
        payload.buffer = await readFile(payload.icon.buffer)
        delete payload.icon.buffer
      }

      if (payload._id) {
        try {
          await state.services.statuses.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Statuses) Modificat Status: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Statuses) Eroare modificare Status: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.statuses.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Statuses) Creat Status: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Statuses) Eroare creare Status: ' + err.message })
        }
      }
      dispatch('fetchStatuses')
    },
    async deleteStatus ({ state, dispatch }, payload) {
      try {
        await state.services.statuses.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Statuses) Eroare stergere Status: ' + err.message })
      }
      dispatch('fetchStatuses')
    },
    setStatusesOptions ({ commit, dispatch }, payload) {
      commit('setStatusesOptions', payload)
      dispatch('fetchStatuses')
    },
    setStatusesSearch ({ commit, dispatch }, payload) {
      commit('setStatusesSearch', payload)
      commit('resetStatusesPage')
      dispatch('fetchStatuses')
    },
    setStatusesApl ({ commit, dispatch }, payload) {
      commit('setStatusesApl', payload)
      dispatch('fetchStatuses')
    },
    setStatusesCategory ({ commit, dispatch }, payload) {
      commit('setStatusesCategory', payload)
      dispatch('fetchStatuses')
    },

    fetchAllCategories ({ state }, payload) {
      if (payload && payload.apl_id) {
        const query = {
          $paginate: false,
          $populate: ['markerCount', 'statusCount'],
          apl_id: payload.apl_id
        }

        return state.services.categories.find({ query })
      } else {
        return state.services.categories.find({
          query: {
            $populate: ['markerCount', 'statusCount'],
            $paginate: false,
            $sort: { apl_id: 1 }
          }
        })
      }
    },
    fetchCategories: _debounce(async function ({ state, commit, dispatch }, payload = null) {
      try {
        commit('setCategoriesLoading', true)

        let query = {
          $populate: [
            { path: 'apl_id', populate: ['markerCount', 'categoryCount', 'statusCount'] },
            { path: 'markerCount' },
            { path: 'statusCount' }
          ]
        }

        if (payload) {
          query.apl_id = payload
        }

        if (state.auth.user && state.categories.options.itemsPerPage) {
          if (state.categories.search) {
            query.$or = [
              { name: { $regex: state.categories.search, $options: 'i' } },
              { value: { $regex: state.categories.search, $options: 'i' } }
            ]
          }
          if (state.categories.apl_id !== null) {
            query.apl_id = state.categories.apl_id
          }

          if (state.categories.options.itemsPerPage !== -1) {
            query.$limit = state.categories.options.itemsPerPage
            query.$skip = (state.categories.options.page - 1) * state.categories.options.itemsPerPage
            query.$sort = state.categories.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.categories.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.categories.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.categories.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }

          if (payload) {
            query.apl_id = payload
          }
        }

        const result = await state.services.categories.find({ query })
        commit('setCategories', result)
        commit('setCategoriesLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Categories) Eroare la citire Categorii...' })
      }
    }, 500),
    async saveCategory ({ state, dispatch }, payload) {
      if (payload.icon.buffer instanceof File) {
        payload.buffer = await readFile(payload.icon.buffer)
        delete payload.icon.buffer
      }

      if (payload._id) {
        try {
          await state.services.categories.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Categories) Modificat Categorie: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Categories) Eroare modificare Categorie: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.categories.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Categories) Creat Categorie: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Categories) Eroare creare Categorie: ' + err.message })
        }
      }
      dispatch('fetchCategories')
    },
    async deleteCategory ({ state, dispatch }, payload) {
      try {
        await state.services.categories.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Categories) Eroare stergere Categorie: ' + err.message })
      }
      dispatch('fetchCategories')
    },
    setCategoriesOptions ({ commit, dispatch }, payload) {
      commit('setCategoriesOptions', payload)
      dispatch('fetchCategories')
    },
    setCategoriesSearch ({ commit, dispatch }, payload) {
      commit('setCategoriesSearch', payload)
      commit('resetCategoriesPage')
      dispatch('fetchCategories')
    },
    setCategoriesApl ({ commit, dispatch }, payload) {
      commit('setCategoriesApl', payload)
      dispatch('fetchCategories')
    },

    fetchAllMarkers ({ state }, payload) {
      if (payload && payload.apl_id) {
        const query = {
          $paginate: false,
          apl_id: payload.apl_id,
          $populate: [
            { path: 'apl_id', model: 'apls' },
            { path: 'status_id', model: 'statuses' },
            { path: 'category_id', model: 'categories' }
          ],
          availability: 1
        }

        if (payload.status_id) {
          query.status_id = payload.status_id
        }
        if (payload.category_id) {
          query.category_id = payload.category_id
        }

        return state.services.markers.find({ query })
      }
      return []
    },
    fetchMarkers: _debounce(async function ({ state, commit, dispatch }, payload = null) {
      try {
        commit('setMarkersLoading', true)

        const collation = {
          locale: 'ro',
          numericOrdering: true
        }

        const query = {
          $collation: collation,
          $populate: [
            { path: 'apl_id', model: 'apls', populate: ['markerCount', 'categoryCount', 'statusCount'] },
            { path: 'status_id', model: 'statuses', populate: 'markerCount' },
            { path: 'category_id', model: 'categories', populate: ['markerCount', 'statusCount'] }
          ]
        }

        if (payload) {
          query.apl_id = payload.apl_id
        }

        if (state.auth.user && state.markers.options.itemsPerPage) {
          if (state.markers.apl_id !== null) {
            query.apl_id = state.markers.apl_id
          }

          if (state.markers.status_id !== null) {
            query.status_id = state.markers.status_id
          }

          if (state.markers.category_id !== null) {
            query.category_id = state.markers.category_id
          }

          if (state.markers.availability !== null) {
            query.availability = state.markers.availability
          }

          if (state.markers.search) {
            query.$or = [
              { address: { $regex: state.markers.search, $options: 'i' } },
              { unique: { $regex: state.markers.search, $options: 'i' } },
              { unique_apl: { $regex: state.markers.search, $options: 'i' } },
              { status: { $regex: state.markers.search, $options: 'i' } },
              { category: { $regex: state.markers.search, $options: 'i' } }
            ]
          }

          if (state.markers.options.itemsPerPage !== -1) {
            query.$limit = state.markers.options.itemsPerPage
            query.$skip = (state.markers.options.page - 1) * state.markers.options.itemsPerPage
            query.$sort = state.markers.options.sortBy.reduce((acc, field, index) => {
              let fld = field

              if (field.includes('.')) {
                fld = field.substring(0, field.indexOf('.'))
              }

              acc[fld] = state.markers.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.markers.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.markers.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query.$limit = 10
          query.$skip = 0
        }

        const result = await state.services.markers.find({ query })
        commit('setMarkers', result)
        commit('setMarkersLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Markers) Eroare la citire Markere...' })
      }
    }, 500),

    async deleteMarker ({ state, dispatch }, payload) {
      try {
        await state.services.markers.remove(payload)
        dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Markers) Marker sters: ' + payload })
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Markers) Eroare stergere Marker: ' + err.message })
      }
      dispatch('fetchMarkers')
    },
    setMarkersOptions ({ commit, dispatch }, payload) {
      commit('setMarkersOptions', payload)
      dispatch('fetchMarkers')
    },
    setMarkersSearch ({ commit, dispatch }, payload) {
      commit('setMarkersSearch', payload)
      commit('resetMarkersPage')
      dispatch('fetchMarkers')
    },
    setMarkersApl ({ commit, dispatch }, payload) {
      commit('setMarkersApl', payload)
      dispatch('fetchMarkers')
    },
    setMarkersStatus ({ commit, dispatch }, payload) {
      commit('setMarkersStatus', payload)
      dispatch('fetchMarkers')
    },
    setMarkersCategory ({ commit, dispatch }, payload) {
      commit('setMarkersCategory', payload)
      dispatch('fetchMarkers')
    },
    setMarkersAvailability ({ commit, dispatch }, payload) {
      commit('setMarkersAvailability', payload)
      dispatch('fetchMarkers')
    },
    downloadMarkers ({ state }) {
      const query = {
        $paginate: false,
        $populate: [
          { path: 'apl_id', model: 'apls' },
          { path: 'status_id', model: 'statuses' }
        ]
      }

      if (state.auth.user && state.markers.options.itemsPerPage) {
        if (state.markers.apl_id !== null) {
          query.apl_id = state.markers.apl_id
        }

        if (state.markers.status_id !== null) {
          query.status_id = state.markers.status_id
        }

        if (state.markers.availability !== null) {
          query.availability = state.markers.availability
        }

        if (state.markers.search) {
          query.$or = [
            { address: { $regex: state.markers.search, $options: 'i' } },
            { unique: { $regex: state.markers.search, $options: 'i' } },
            { unique_apl: { $regex: state.markers.search, $options: 'i' } },
            { status: { $regex: state.markers.search, $options: 'i' } }
          ]
        }
      }

      return state.services.markers.find({ query })
    },
    async importMarker ({ state, dispatch }, payload) {
      saverWorker.onmessage = null
      return new Promise((resolve, reject) => {
        const token = state.auth.token
        saverWorker.postMessage({ message: 'saveMarker', token, payload })
        saverWorker.onmessage = e => {
          dispatch('saveLogItem', { type: 'success', user: state.auth.user?.username ?? 'no user', text: '(save-marker) Salvat marker: ' + (payload.importMandatory ? payload.mandatory.unique : payload.details.marker_id) })
          resolve(e.result)
        }
        saverWorker.onerror = e => {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(save-marker) Eroare la salvare marker...' + (payload.importMandatory ? payload.mandatory.unique : payload.details.marker_id) })
          console.log(e)
          reject(e)
        }
      })
    },

    fetchUserTypes: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setUserTypesLoading', true)

        let query = {}

        if (state.auth.user && state.userTypes.options.itemsPerPage) {
          if (state.userTypes.search) {
            query.$or = [
              { title: { $regex: state.userTypes.search, $options: 'i' } },
              { description: { $regex: state.userTypes.search, $options: 'i' } }
            ]
          }

          if (state.userTypes.options.itemsPerPage !== -1) {
            query.$limit = state.userTypes.options.itemsPerPage
            query.$skip = (state.userTypes.options.page - 1) * state.userTypes.options.itemsPerPage
            query.$sort = state.userTypes.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.userTypes.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.userTypes.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.userTypes.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }
        }

        const result = await state.services.userTypes.find({ query })
        commit('setUserTypes', result)
        commit('setUserTypesLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(UserTypes) Eroare la citire User Types...' })
      }
    }, 500),
    async saveUserType ({ state, dispatch }, payload) {
      if (payload._id) {
        try {
          await state.services.userTypes.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(UserTypes) Modificat User Type: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(UserTypes) Eroare modificare User Type: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.userTypes.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(UserTypes) Creat User Type: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(UserTypes) Eroare creare User Type: ' + err.message })
        }
      }
      dispatch('fetchUserTypes')
    },
    async deleteUserType ({ state, dispatch }, payload) {
      try {
        await state.services.userTypes.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(UserTypes) Eroare stergere UserType: ' + err.message })
      }
      dispatch('fetchUserTypes')
    },
    setUserTypesOptions ({ commit, dispatch }, payload) {
      commit('setUserTypesOptions', payload)
      dispatch('fetchUserTypes')
    },
    setUserTypesSearch ({ commit, dispatch }, payload) {
      commit('setUserTypesSearch', payload)
      commit('resetUserTypesPage')
      dispatch('fetchUserTypes')
    },

    fetchAllPropertyGroups ({ state }, payload) {
      const query = {
        $paginate: false,
        $populate: ['propertyCount']
      }

      if (payload) {
        query.visible = true
      }

      return state.services.propertyGroups.find({ query })
    },
    fetchPropertyGroups: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setPropertyGroupsLoading', true)

        let query = {
          $populate: [
            { path: 'apl_id', populate: ['markerCount', 'propertyGroupCount', 'propertyCount'] },
            { path: 'propertyCount' }
          ]
        }

        if (state.auth.user && state.propertyGroups.options.itemsPerPage) {
          if (state.propertyGroups.apl_id !== null) {
            query.apl_id = state.propertyGroups.apl_id
          }
          if (state.propertyGroups.search) {
            query.$or = [
              { label: { $regex: state.propertyGroups.search, $options: 'i' } },
              { info: { $regex: state.propertyGroups.search, $options: 'i' } }
            ]
          }

          if (state.propertyGroups.options.itemsPerPage !== -1) {
            query.$limit = state.propertyGroups.options.itemsPerPage
            query.$skip = (state.propertyGroups.options.page - 1) * state.propertyGroups.options.itemsPerPage
            query.$sort = state.propertyGroups.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.propertyGroups.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.propertyGroups.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.propertyGroups.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }
        }

        const result = await state.services.propertyGroups.find({ query })
        commit('setPropertyGroups', result)
        commit('setPropertyGroupsLoading', false)
      } catch (err) {
        console.log(err)
        commit('setPropertyGroupsLoading', false)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(PropertyGroups) Eroare la citire Property Group...' })
      }
    }, 500),
    async savePropertyGroup ({ state, dispatch }, payload) {
      if (payload.icon.buffer instanceof File) {
        payload.buffer = await readFile(payload.icon.buffer)
        delete payload.icon.buffer
      }

      if (payload._id) {
        try {
          await state.services.propertyGroups.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(PropertyGroups) Modificat Property Group: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(PropertyGroups) Eroare modificare Property Group: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.propertyGroups.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(PropertyGroups) Creat Property Group: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(PropertyGroups) Eroare creare Property Group: ' + err.message })
        }
      }
      dispatch('fetchPropertyGroups')
    },
    async deletePropertyGroup ({ state, dispatch }, payload) {
      try {
        await state.services.propertyGroups.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(PropertyGroups) Eroare stergere Property Group: ' + err.message })
      }
      dispatch('fetchPropertyGroups')
    },
    setPropertyGroupsOptions ({ commit, dispatch }, payload) {
      commit('setPropertyGroupsOptions', payload)
      dispatch('fetchPropertyGroups')
    },
    setPropertyGroupsSearch ({ commit, dispatch }, payload) {
      commit('setPropertyGroupsSearch', payload)
      commit('resetPropertyGroupsPage')
      dispatch('fetchPropertyGroups')
    },
    setPropertyGroupsApl ({ commit, dispatch }, payload) {
      commit('setPropertyGroupsApl', payload)
      dispatch('fetchPropertyGroups')
    },

    async fetchAllPropertiesForApl ({ state }, payload) {
      if (payload && payload.apl_id) {
        const groups = await state.services.propertyGroups.find({
          query: {
            $paginate: false,
            apl_id: payload.apl_id,
            $sort: { index: 1 }
          }
        })

        if (groups.length) {
          for (const group of groups) {
            group.properties = await state.services.properties.find({
              query: {
                $paginate: false,
                propertygroup_id: group._id,
                $sort: { index: 1 }
              }
            })
          }

          return groups
        }
      } else {
        return []
      }
    },
    async fetchEnergyPropsForApl ({ state }, payload) {
      if (payload && payload.apl_id) {
        const query = {
          $paginate: false,
          apl_id: payload.apl_id,
          energy: true,
          $sort: { index: 1 },
          $select: ['code', 'label']
        }

        try {
          const properties = state.services.properties.find({ query })
          return properties
        } catch (err) {
          console.log(err)
          return []
        }
      } else {
        return []
      }
    },
    fetchProperties: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setPropertiesLoading', true)

        let query = {
          $populate: [
            { path: 'propertygroup_id', populate: 'propertyCount' },
            { path: 'apl_id', populate: ['markerCount', 'propertyGroupCount', 'propertyCount'] },
          ]
        }

        if (state.auth.user && state.properties.options.itemsPerPage) {
          if (state.properties.apl_id !== null) {
            query.apl_id = state.properties.apl_id
          }
          if (state.properties.propertygroup_id !== null) {
            query.propertygroup_id = state.properties.propertygroup_id
          }
          if (state.properties.search) {
            query.$or = [
              { label: { $regex: state.properties.search, $options: 'i' } },
              { info: { $regex: state.properties.search, $options: 'i' } }
            ]
          }

          if (state.properties.options.itemsPerPage !== -1) {
            query.$limit = state.properties.options.itemsPerPage
            query.$skip = (state.properties.options.page - 1) * state.properties.options.itemsPerPage
            query.$sort = state.properties.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.properties.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.properties.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.properties.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }
        }

        const result = await state.services.properties.find({ query })
        commit('setProperties', result)
        commit('setPropertiesLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Properties) Eroare la citire Property Group...' })
      }
    }, 500),
    async saveProperty ({ state, dispatch }, payload) {
      if (payload.icon.buffer instanceof File) {
        payload.buffer = await readFile(payload.icon.buffer)
        delete payload.icon.buffer
      }

      if (payload._id) {
        try {
          await state.services.properties.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Properties) Modificat Property: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Properties) Eroare modificare Property: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.properties.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Properties) Creat Property: ' + payload.name })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Properties) Eroare creare Property: ' + err.message })
        }
      }
      dispatch('fetchProperties')
    },
    async deleteProperty ({ state, dispatch }, payload) {
      try {
        await state.services.properties.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Properties) Eroare stergere Property Group: ' + err.message })
      }
      dispatch('fetchProperties')
    },
    setPropertiesOptions ({ commit, dispatch }, payload) {
      commit('setPropertiesOptions', payload)
      dispatch('fetchProperties')
    },
    setPropertiesSearch ({ commit, dispatch }, payload) {
      commit('setPropertiesSearch', payload)
      commit('resetPropertiesPage')
      dispatch('fetchProperties')
    },
    setPropertiesApl ({ commit, dispatch }, payload) {
      commit('setPropertiesApl', payload)
      dispatch('fetchProperties')
    },
    setPropertiesPropertyGroup ({ commit, dispatch }, payload) {
      commit('setPropertiesPropertyGroup', payload)
      dispatch('fetchProperties')
    },

    async fetchMarkerDetails ({ state }, payload) {
      if (payload && payload._id) {
        try {
          const details = await state.services.details.find({
            query: {
              $paginate: false,
              marker_id: payload._id
            }
          })

          return details[0] || {}
        } catch (err) {
          console.log(err)
          return {}
        }
      } else {
        return {}
      }
    },

    fetchDictionary: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setDictionaryLoading', true)

        const query = { }

        if (state.dictionary.search) {
          query.$or = [
            { key: { $regex: state.dictionary.search, $options: 'i' } },
            { description: { $regex: state.dictionary.search, $options: 'i' } }
          ]
        }

        if (state.dictionary.options.itemsPerPage !== -1) {
          query.$limit = state.dictionary.options.itemsPerPage
          query.$skip = (state.dictionary.options.page - 1) * state.dictionary.options.itemsPerPage
          query.$sort = state.dictionary.options.sortBy.reduce((acc, field, index) => {
            acc[field] = state.dictionary.options.sortDesc[index] ? -1 : 1
            return acc
          }, {})
        } else {
          query.$sort = state.dictionary.options.sortBy.reduce((acc, field, index) => {
            acc[field] = state.dictionary.options.sortDesc[index] ? -1 : 1
            return acc
          }, {})
          query.$paginate = false
        }

        const result = await state.services.dictionary.find({ query })
        commit('setDictionary', result)
        commit('setDictionaryLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Dictionary) Eroare la citire Dictionar...' })
      }
    }, 500),
    fetchDictionaryKeys: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setDictionaryLoading', true)

        const query = { $select: ['key'], $paginate: false }

        const result = await state.services.dictionary.find({ query })
        commit('setDictionaryKeys', result)
        commit('setDictionaryLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Dictionary) Eroare la citire Dictionar...' })
      }
    }, 500),
    async saveDictionary ({ state, dispatch }, payload) {
      if (payload._id) {
        try {
          await state.services.dictionary.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Dictionary) Modificat Dictionar: ' + payload.key })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Dictionary) Eroare modificare Dictionar: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.dictionary.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Dictionary) Creat Dictionar: ' + payload.key })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Dictionary) Eroare creare Dictionar: ' + err.message })
        }
      }
      dispatch('fetchDictionary')
      dispatch('fetchDictionaryKeys')
      dispatch('generateDictionaryJSON')
    },
    async deleteDictionary ({ state, dispatch }, payload) {
      try {
        await state.services.dictionary.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Dictionary) Eroare stergere Dictionar: ' + err.message })
      }
      dispatch('fetchDictionary')
      dispatch('fetchDictionaryKeys')
      dispatch('generateDictionaryJSON')
    },
    setDictionaryOptions ({ commit, dispatch }, payload) {
      commit('setDictionaryOptions', payload)
      // this gets triggered before the component is mounted
      dispatch('fetchDictionary')
      dispatch('fetchDictionaryKeys')
    },
    setDictionarySearch ({ commit, dispatch }, payload) {
      commit('setDictionarySearch', payload)
      commit('resetDictionaryPage')
      dispatch('fetchDictionary')
      dispatch('fetchDictionaryKeys')
    },
    async importDictionary ({ state, commit, dispatch }, payload) {
      const total = payload.length
      let current = 0
      let progress = Number(current * total / 100).toFixed(2)

      commit('setDictionaryImportProgressVisible', true)
      commit('setDictionaryImportProgressValue', progress)

      for (const term of payload) {
        current++
        try {
          const resp = await state.services.dictionary.patch(null, term, {
            query: {
              key: term.key,
              $mongoose: {
                upsert: true
              }
            }
          })
          dispatch('saveLogItem', { type: 'success', user: state.auth.user?.username ?? 'no user', text: '(import-dictionary) Importat Dictionar, create: ' + JSON.stringify(resp) })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(import-dictionary) Eroare la import... ' + JSON.stringify(err) })
        } finally {
          progress = Number(current * 100 / total).toFixed(2)
          commit('setDictionaryImportProgressValue', progress)
        }
      }
      dispatch('fetchDictionary')
      dispatch('generateDictionaryJSON')
      commit('setDictionaryImportProgressValue', 0)
      commit('setDictionaryImportProgressVisible', false)

      return 'done'
    },
    generateDictionaryJSON: _debounce(async function ({ state }) {
      state.services.i18n.create({ some: 'dummy', object: 'here' })
    }, 1000),
    generateDictionaryXLSX: _debounce(async function ({ state, commit }) {
      commit('setDictionaryGenerationLoading', true)
      commit('setDictionaryGenerationComplete', false)

      try {
        const generated = await state.services.i18n.get('dummy')
        commit('setDictionaryGenerationLoading', false)
        commit('setDictionaryGenerationComplete', generated)
      } catch (err) {
        console.log(err)
        commit('setDictionaryGenerationLoading', false)
        commit('setDictionaryGenerationComplete', false)
      }
    }, 1000),

    fetchLanguage: _debounce(async function ({ state, commit, dispatch }) {
      try {
        const result = await state.services.language.find({ query: { $paginate: false } })
        commit('setLanguage', result)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Language) Eroare la citire Limbi...' })
      }
    }, 500),
    fetchLanguageKeys: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setLanguageLoading', true)

        const query = { $select: ['languageCode'], $paginate: false }

        const result = await state.services.language.find({ query })
        commit('setLanguageKeys', result)
        commit('setLanguageLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Language) Eroare la citire Limba...' })
      }
    }, 500),
    async saveLanguages ({ state, dispatch }, payload) {
      // use to create multiple languages when importing from dictionary xlsx
      if (payload.length) {
        try {
          for (const newLang of payload) {
            await state.services.language.create({
              title: newLang.lang.toUpperCase(),
              countryCode: newLang.lang.toUpperCase(),
              languageCode: newLang.lang
            })
          }
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Language) Adaugat Limba: ' + payload.languageCode })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Language) Eroare adaugare Limba: ' + err.message })
        }
      }
      dispatch('fetchLanguage')
      dispatch('generateDictionaryJSON')
    },
    async saveLanguage ({ state, dispatch }, payload) {
      if (payload._id) {
        try {
          await state.services.language.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Language) Modificat Limba: ' + payload.title })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Language) Eroare modificare Limba: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.language.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Language) Creat Limba: ' + payload.title })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Language) Eroare creare Limba: ' + err.message })
        }
      }
      dispatch('fetchLanguage')
      dispatch('generateDictionaryJSON')
    },
    async deleteLanguage ({ state, dispatch }, payload) {
      try {
        await state.services.language.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Language) Eroare stergere Limba: ' + err.message })
      }
      dispatch('fetchLanguage')
    },
    setLanguageOptions ({ commit, dispatch }, payload) {
      commit('setLanguageOptions', payload)
      // this gets triggered before the component is mounted
      dispatch('fetchLanguage')
      dispatch('fetchLanguageKeys')
    },
    setLanguageSearch ({ commit, dispatch }, payload) {
      commit('setLanguageSearch', payload)
      commit('resetLanguagePage')
      dispatch('fetchLanguage')
      dispatch('fetchLanguageKeys')
    },

    setupSaverWorker (store, payload) {
      return new Promise(resolve => {
        if (saverWorker) {
          saverWorker.terminate()
          saverWorker = null
        }

        if (payload) {
          saverWorker = new Worker(new URL('../workers/saver.worker.js', import.meta.url))
        }

        resolve()
      })
    },

    async createGeojson ({ state }, payload) {
      await state.services.geojson.create({ map_id: payload })
    },

    async fetchAplsUniques ({ state, commit }, payload) {
      const result = await state.services.apls.find({
        query: {
          $paginate: false,
          $select: ['unique']
        }
      })

      commit('setAplsUniques', Object.freeze(result))
    },
    async fetchAplsSlugs ({ state, commit }, payload) {
      const result = await state.services.apls.find({
        query: {
          $paginate: false,
          $select: ['slug']
        }
      })

      commit('setAplsSlugs', Object.freeze(result))
    },

    async fetchUniquesForApl ({ state, commit }, payload) {
      if (payload) {
        const result = await state.services.markers.find({
          query: {
            $paginate: false,
            $select: ['unique'],
            apl_id: payload
          }
        })

        commit('setUniquesForAPl', Object.freeze(result))
      } else {
        commit('setUniquesForAPl', [])
      }
    },

    // action that nukes markers for a given map
    // will cycle through all markers and delete them individually
    // this is done to trigger the hooks and delete the related files
    // will set loading prop of apls item in state to true and then to false when done
    // will log errors if any
    async nukeMarkers ({ state, commit, dispatch }, payload) {
      commit('setAPLsLoading', true)

      const markers = await state.services.markers.find({
        query: {
          $paginate: false,
          apl_id: payload
        }
      })

      for (const marker of markers) {
        try {
          await state.services.markers.remove(marker._id)
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Nuke Markers) Eroare la stergere marker: ' + err.message })
        }
      }

      commit('setAPLsLoading', false)
    },

    fetchUsers: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setUsersLoading', true)

        let query = {}

        if (state.auth.user && state.users.options.itemsPerPage) {
          if (state.users.search) {
            query.$or = [
              { email: { $regex: state.users.search, $options: 'i' } },
              { username: { $regex: state.users.search, $options: 'i' } }
            ]
          }

          if (state.users.options.itemsPerPage !== -1) {
            query.$limit = state.users.options.itemsPerPage
            query.$skip = (state.users.options.page - 1) * state.users.options.itemsPerPage
            query.$sort = state.users.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.users.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
          } else {
            query.$sort = state.users.options.sortBy.reduce((acc, field, index) => {
              acc[field] = state.users.options.sortDesc[index] ? -1 : 1
              return acc
            }, {})
            query.$paginate = false
          }
        } else {
          query = {
            $paginate: false
          }
        }

        const result = await state.services.users.find({ query })
        commit('setUsers', result)
        commit('setUsersLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Users) Eroare la citire Utilizatori...' })
      }
    }, 500),
    fetchUsersUsernames: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setUsersLoading', true)

        const query = { $select: ['username'], $paginate: false }

        const result = await state.services.users.find({ query })
        commit('setUsersUsernames', result)
        commit('setUsersLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Users) Eroare la citire Utilizatori...' })
      }
    }, 500),
    fetchUsersEmails: _debounce(async function ({ state, commit, dispatch }) {
      try {
        commit('setUsersLoading', true)

        const query = { $select: ['email'], $paginate: false }

        const result = await state.services.users.find({ query })
        commit('setUsersEmails', result)
        commit('setUsersLoading', false)
      } catch (err) {
        console.log(err)
        dispatch('saveLogItem', { type: 'error', user: state.auth.user?.username ?? 'no user', text: '(Users) Eroare la citire Utilizatori...' })
      }
    }, 500),
    async saveUser ({ state, dispatch }, payload) {
      if (payload._id) {
        if (!payload.password) delete payload.password
        try {
          await state.services.users.patch(payload._id, payload)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Users) Modificat Utilizator: ' + payload.username })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Users) Eroare modificare Utilizator: ' + err.message })
        }
      } else {
        try {
          const { _id, ...rest } = payload
          await state.services.users.create(rest)
          dispatch('saveLogItem', { type: 'success', user: state.auth.user.username, text: '(Users) Creat Utilizator: ' + payload.username })
        } catch (err) {
          dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Users) Eroare creare Utilizator: ' + err.message })
        }
      }
      dispatch('fetchUsers')
      dispatch('fetchUsersUsernames')
      dispatch('fetchUsersEmails')
    },
    async deleteUser ({ state, dispatch }, payload) {
      try {
        await state.services.users.remove(payload)
      } catch (err) {
        dispatch('saveLogItem', { type: 'error', user: state.auth.user.username, text: '(Users) Eroare stergere Utilizator: ' + err.message })
      }
      dispatch('fetchUsers')
    },
    setUsersOptions ({ commit, dispatch }, payload) {
      commit('setUsersOptions', payload)
      dispatch('fetchUsers')
    },
    setUsersSearch ({ commit, dispatch }, payload) {
      commit('setUsersSearch', payload)
      commit('resetUsersPage')
      dispatch('fetchUsers')
    }
  }
})

let saverWorker = null

const reader = new FileReader()

function readFile (file) {
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file)

    reader.onload = e => {
      const base64 = e.target.result.split('base64,')[1]
      resolve(base64)
    }

    reader.onerror = event => {
      reader.abort()
      reject(new Error('file reader error'))
    }
  })
}
